export default __webpack_public_path__ + "static/media/talk_time.e0a473e9.svg";